import React, { useEffect, useState } from 'react';
import { API, Auth } from 'aws-amplify';
import { useNavigate } from 'react-router-dom';

import '@aws-amplify/ui-react/styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';

type getAccount = [
  {
    checked: boolean;
    accountId: string;
    name: string;
  }
];
const initGetAccount = { checked: false, accountId: "", name: "" };

type AccountListProps = {
  activeLink: VoidFunction;
};

type FailedType =
{
  code: number;
  trace: number;
};

const AccountList: React.FC<AccountListProps> = (props) => {
  const [AccountData, setAccountData] = useState<getAccount>([initGetAccount]);
  const [orgAccData, setOrgAccData] = useState<getAccount>([initGetAccount]);
  const [filterText, setFilterText] = React.useState('');
  //const [loaderClass, setLoaderClass] = React.useState("clearfix d-none");
  const [errorText, setErrorText] = React.useState('');
  const [alertClass, setAlertClass] = React.useState('alert alert-danger d-none');
  const [deleteBtnDisabled, setDeleteBtnDisabled] =  React.useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    getAccountData();
    props.activeLink();
  }, [])

  const getAccountData = async () => {
    try {
      //setLoaderClass('clearfix');
      const apiName = 'MainApi';
      const path = '/account';
      const myInit = {
        headers: {
          Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
        },
      };

      const data = await API.get(apiName, path, myInit);
      const tdata = data.map((x: any) => {
        return {
          checked: false,
          accountId: x.accountId,
          name: x.name
        };
      });
      const sortedData = tdata.sort((a: any, b: any) => a.accountId < b.accountId ? -1 : 1);
      setOrgAccData(sortedData);
      setAccountData(sortedData);
    } catch (err) {
      const dataEnpty: any = [];
      setAccountData(dataEnpty);
      setOrgAccData(dataEnpty);

      setAlertMessage('ACC0101 データの取得に失敗しました。');
    }
  }

  const handleChangeFilterText = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilterText(e.target.value);

    setAccountData(orgAccData.filter(item => {
      return item.name.includes(e.target.value) || item.accountId.includes(e.target.value);
    }) as getAccount);
  }

  const handleClickBtn = (id: string) => {
    navigate('/account/mng', { state: { 'id': id } });
  }

  const handleClickAddBtn = () => {
    navigate('/account/add');
  }

  const handleClickDelBtn = async () => {
    let delMsgList = [];
    let delReqList  = [];

    for (var item of orgAccData) {
      if (item.checked){ 
        delMsgList.push(item.accountId + ' ' + item.name);
        delReqList.push(item.accountId);
      }
    }


    const delComfirmMessage = delMsgList.join('\n');
    let resultDel = false;
    if (delComfirmMessage !== "") {
      resultDel = window.confirm("以下のグループを削除しますか？\n" + delComfirmMessage);
    }

    if (resultDel) {
      try {
        const delReqIds = delReqList;
        const bodydata = {
          accountIds: delReqIds
        };
        const apiName = 'MainApi';
        const path = '/account';
        const myInit = {
          headers: {
            Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`,
          },
          body: bodydata
        };
        const data = await API.del(apiName, path, myInit);
        const retVal =  JSON.parse(JSON.stringify(data.retVal)) as FailedType;
        if (retVal.code === 200) {         
          setSuccessMessage("グループの削除が完了しました。");
          getAccountData()
          handleClickAllFree();
        } else if (retVal.trace === 1) {
          setAlertMessage("ACC0102 グループの削除に失敗しました。削除対象を絞り、再度削除してください。");
        } else if (retVal.trace === 2) {
          setAlertMessage("ACC0103 グループの削除に失敗しました。削除対象を絞り、再度削除してください。");
        } else if (retVal.trace === 3) {
          setAlertMessage("ACC0104 グループの削除に失敗しました。削除対象を絞り、再度削除してください。");
        } else {
          setAlertMessage("ACC0105 グループの削除に失敗しました。削除対象を絞り、再度削除してください。");
        }
      } catch (err) {
        setAlertMessage("ACC0106 グループの削除に失敗しました。削除対象を絞り、再度削除してください。");
      }
    }  
  }

  const handleClickAllCheck = () => {
    for (let i: number = 0; i < AccountData.length; i++) {
      AccountData[i].checked = true;
      let elem = document.getElementById('id'+AccountData[i].accountId) as HTMLInputElement;
      elem.checked = true;
    }

    for (let i: number = 0; i < orgAccData.length; i++) {
      const accData =  AccountData.find((x) => x.accountId === orgAccData[i].accountId)
      if (accData){
        orgAccData[i].checked = accData.checked;
      }
    }

    setAccountData(AccountData);
    setOrgAccData(orgAccData);

    if (orgAccData.findIndex((x) => x.checked ) === -1 ){
      setDeleteBtnDisabled(true);
    } else {
      setDeleteBtnDisabled(false);
    }
  }

  const handleClickAllFree = () => {
    for (let i: number = 0; i < AccountData.length; i++) {
      AccountData[i].checked = false;
      let elem = document.getElementById('id'+AccountData[i].accountId) as HTMLInputElement;
      elem.checked = false;
    }

    for (let i: number = 0; i < orgAccData.length; i++) {
      const accData =  AccountData.find((x) => x.accountId === orgAccData[i].accountId);
      if (accData){
        orgAccData[i].checked = accData.checked;
      }
    }

    setAccountData(AccountData);
    setOrgAccData(orgAccData);

    if (orgAccData.findIndex((x) => x.checked ) === -1 ){
      setDeleteBtnDisabled(true);
    } else {
      setDeleteBtnDisabled(false);
    }
  }

  const handleChangeCheck = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    AccountData[index].checked = e.target.checked;
    const disableFlg = AccountData.find((x) => x.checked) ? false : true;
    setDeleteBtnDisabled(disableFlg);
  }

  const setAlertMessage = (message: string) => {
    setErrorText(message);
    setAlertClass('alert alert-danger');
  }

  const setSuccessMessage = (message: string) => {
    setErrorText(message);
    setAlertClass('alert alert-success');
  }

  return (
    <div className="p-3">

      <h4>グループの管理</h4>
      <div className={alertClass} role="alert">{errorText}</div>
      <div>
        <div className='form-group m-0 p-0 '>
          <input type="button" className='btn btn-primary mr-3' id="updateBtn" value={'追加'} onClick={() => handleClickAddBtn()} ></input>
          <input type="button" className='btn btn-primary' id="delBtn" disabled={deleteBtnDisabled} value={'削除'} onClick={() => handleClickDelBtn()} ></input>
        </div>
      </div>
      <div>
        <div className='form-group mt-3' style={{ 'width': '700px' }}>
          <input type="text" id="filter_text" value={filterText} placeholder='フィルター' onChange={(e) => handleChangeFilterText(e)}></input>
        </div>
      </div>
      <div>
        <div className='form-group m-0 p-0 '>
          <input type="button" className='btn btn-primary mr-3' id="updateBtn" value={'全選択'} onClick={() => handleClickAllCheck()} ></input>
          <input type="button" className='btn btn-primary' id="delBtn"  value={'全解除'} onClick={() => handleClickAllFree()} ></input>
        </div>
      </div>
      {
        (() => {
          if (AccountData.length) {
            if (AccountData[0].accountId === '') {
              return;
            }
            else {

              let showData = AccountData.map((data, index) => (
                <div key={'row' + data.accountId ? data.accountId : index}>
                  <input className="align-middle" type="checkbox" key={'checkbox' + (data.accountId ? data.accountId : index)} id={'id'+ data.accountId} defaultChecked={data.checked} onChange={(e) => handleChangeCheck(e, index)} />
                  <input type="button" className="btn btn-link" key={'btn' + (data.accountId ? data.accountId : index)} value={data.accountId + ' ' + data.name} onClick={() => handleClickBtn(data.accountId)} />
                </div>
              ));
              return (showData);
            }
          }
          else {

            return (
              <h6>データがありません。</h6>
            );
          }
        })()
      }
      {/* <div className={loaderClass}>
        <div className="spinner-border float-left" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div> */}
    </div>
  );
}

export default AccountList;
